import React from "react";
import ExlyImage from "repoV2/features/Common/modules/ExlyImage/ExlyImage";

import { PoweredByExly } from "repoV2/features/CreatorPages/modules/PoweredByExly";
import { ssl_checkout_asset } from "repoV2/features/Payments/Payments.constants";
import AcceptedPayments from "../AcceptedPayments/AcceptedPayments";
import styles from "./FooterSection.module.scss";

const FooterSection = () => {
    return (
        <div className={styles.container}>
            <div className={styles.exlyBranding}>
                <PoweredByExly
                    exlyTextClass={styles.exlyLogo}
                    exlyClickDisabled={false}
                />
            </div>
            <div className={styles.paymentAndSslContainer}>
                <AcceptedPayments />
                <ExlyImage
                    src={ssl_checkout_asset.src}
                    alt={ssl_checkout_asset.alt}
                    className={styles.sslImageStyle}
                />
            </div>
        </div>
    );
};

export default FooterSection;
